import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var Globe06 = function Globe06(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "m2.6868 15.6451 1.9081-1.1016a.5.5 0 0 1 .342-.0584l3.7545.7027c.3086.0577.5934-.1798.592-.4937l-.0146-3.2896a.5.5 0 0 1 .0682-.2545l1.8947-3.2438a.5.5 0 0 0-.0226-.5396l-3.1902-4.541M19.0002 4.859C13.5002 7.5 16.5 11 17.5002 11.5c1.8771.9384 4.4874 1 4.4874 1q.0123-.2484.0124-.5c0-5.5228-4.4772-10-10-10S2 6.4772 2 12s4.4772 10 10 10q.2516 0 .5-.0123m4.2578-.0479L13.591 13.591l8.3488 3.1668-3.7022 1.4798z"
    })
  }));
};
export default Globe06;